import { AlarmLog } from './AlarmLog';
export class Camera{
    s_ins: number;
    deal_id: string;
    s_cam: number;
    desc_cam: string;
    panel: string;
    camera_video: string;
    camera_voice: string;
    det_typ: string;
    dwnl_skill: string;
    zid: string;
    camera_url: string;
    online: number;
    alarmsLog: AlarmLog[];
    constructor(){
        this.online = 0;
        this.alarmsLog = [];
    }
}